import React, { ReactNode, VFC } from 'react';
import styled from 'styled-components';
import makeStyles from '@material-ui/core/styles/makeStyles';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiSlider, { SliderProps } from '@material-ui/core/Slider';
import Grid from '@material-ui/core/Grid';

interface Props extends SliderProps {
  startLabel: ReactNode;
  endLabel: ReactNode;
}
const SliderWithLabel: VFC<Props> = ({
  startLabel,
  endLabel,
  ...rest
}: Props) => {
  const { containerGridRoot, labelGridRoot, sliderGridRoot } = useStyles();
  return (
    <Grid container classes={{ root: containerGridRoot }}>
      <FlexGrid item classes={{ root: labelGridRoot }}>
        <Label>{startLabel}</Label>
      </FlexGrid>
      <FlexGrid item xs classes={{ root: sliderGridRoot }}>
        <StyledSlider {...rest} />
      </FlexGrid>
      <FlexGrid item classes={{ root: labelGridRoot }}>
        <Label>{endLabel}</Label>
      </FlexGrid>
    </Grid>
  );
};

export default SliderWithLabel;

const useStyles = makeStyles((theme) => ({
  containerGridRoot: {
    minHeight: '50px',
  },
  labelGridRoot: {
    justifyContent: 'center',
    width: '60px',

    [theme.breakpoints.up('sm')]: {
      width: '85px',
    },
  },
  sliderGridRoot: {
    margin: theme.spacing(0, 2),
  },
}));

const BASE_SIZE = 10;
const StyledSlider = withStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  mark: {
    width: `${BASE_SIZE}px`,
    height: `${BASE_SIZE}px`,
    borderRadius: `${BASE_SIZE}px`,
    // topだけBASE_SIZEに対する調整を行う
    top: '15px',

    [theme.breakpoints.up('md')]: {
      top: '8px',
    },
  },
  markLabel: {
    fontSize: theme.typography.pxToRem(11),
  },
  markActive: {
    opacity: 'initial',
    backgroundColor: 'currentColor',
  },
}))(MuiSlider);

const FlexGrid = styled(Grid)`
  display: flex;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: black;
  margin: auto;
`;
